export class InputIdRequest {
    inputId: number;
   
    /**
     * 
     * @param inputId 
     */
    constructor(inputId: number){
        this.inputId = inputId;
    }
}
